import { Star } from "lucide-react";
import { useApp } from "../context/AppContext";

export const useIsOriginal = (address) => {
  const { config } = useApp();
  return !!address && !!config?.original_token && address.toLowerCase() === config.original_token;
};

// Marks STING, the original token representing HIVEVORA (address set by the operator, not user-claimable).
export const OriginalBadge = ({ address, large }) => {
  const yes = useIsOriginal(address);
  if (!yes) return null;
  return (
    <Star data-testid={large ? "original-token-badge" : `original-badge-${address.toLowerCase()}`} aria-label="Original HIVEVORA token"
      className={`inline-block shrink-0 fill-yellow-400 text-yellow-400 ${large ? "h-6 w-6" : "h-3.5 w-3.5"}`}><title>STING — the original HIVEVORA token</title></Star>
  );
};
